/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  meta.js
 */

import { priceChartMetaSelectorsCreator, selectDetailPriceChart } from '../priceChart'

const detailPriceChartMetaSelectors = priceChartMetaSelectorsCreator(selectDetailPriceChart)

export const {
  selectCityPriceChartMeta,
  selectHoodPriceChartMeta,
  selectCityPriceChartCurrentKey,
  selectCityPriceChartFetchingError,
  selectCityPriceChartFetching,
  selectCityPriceChartFetchingKey,
  selectHoodPriceChartCurrentKey,
  selectHoodPriceChartFetchingError,
  selectHoodPriceChartFetching,
  selectHoodPriceChartFetchingKey,
} = detailPriceChartMetaSelectors
